// Fisher-Yates partial shuffle, stops after `count` swaps — O(count), not
// O(n log n) like a full sort-based shuffle, and avoids the classic
// Math.random()-in-sort-comparator bias bug. `randomFn` is injectable so
// tests can be deterministic (production callers omit it and get
// Math.random).
export function pickRandomSample(items, count, randomFn = Math.random) {
  const pool = [...items];
  const n = Math.min(count, pool.length);
  for (let i = 0; i < n; i++) {
    const j = i + Math.floor(randomFn() * (pool.length - i));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, n);
}
